import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Download, Printer, Brain, Search, FileText, Users, Smartphone, ShieldCheck, Zap } from 'lucide-react';
import { Countdown } from './components/Countdown';
import { TestimonialCarousel } from './components/TestimonialCarousel';
import { FAQAccordion } from './components/FAQAccordion';
import { PurchasePopup } from './components/PurchasePopup';
const COVER_URL = 'https://cdn.magicpatterns.com/uploads/avzypTqfjyDGkvE2n5EqaY/PORTADA_MURDOKU.webp';
const CHECKOUT_URL = 'https://pago.atlasdigitalhub.com/cart/43035121516642:1';
const VIDEO_URL = 'https://cdn.magicpatterns.com/uploads/4wzELUP6qiRd981MUJi4s6/IMG_8693.MOV';
export function App() {
  useEffect(() => {
    // Meta Pixel Code - Safely injected
    const win = window as any;
    if (!win.fbq) {
      win.fbq = function () {
        win.fbq.callMethod ? win.fbq.callMethod.apply(win.fbq, arguments) : win.fbq.queue.push(arguments);
      };
      if (!win._fbq) win._fbq = win.fbq;
      win.fbq.push = win.fbq;
      win.fbq.loaded = !0;
      win.fbq.version = '2.0';
      win.fbq.queue = [];
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    win.fbq('init', '989000920158429');
    win.fbq('track', 'PageView');
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=989000920158429&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
  }, []);
  return <div className="min-h-screen font-sans text-[#1E1E1E] bg-[#F7F1E3] overflow-x-hidden" data-id="element-0">
      <PurchasePopup data-id="element-1" />
      {/* 1. Top Bar */}
      <div className="bg-[#1E1E1E] text-white text-center py-2 text-sm font-semibold tracking-widest uppercase" data-id="element-2">
        PRODUCTO 100% DIGITAL · LIBRO COMPLETO
      </div>

      {/* 2. Promo Bar */}
      <div className="bg-[#C62828] text-white text-center py-3 font-bold flex items-center justify-center gap-2 shadow-md sticky top-0 z-50" data-id="element-3">
        <Zap size={20} className="animate-pulse text-[#F4D35E]" data-id="element-4" />
        <span data-id="element-5">OFERTA PROMOCIONAL ACTIVA</span>
        <Countdown data-id="element-6" />
      </div>

      {/* 3. Hero Section */}
      <section className="relative bg-[#5E1A8A] text-white pt-16 pb-24 overflow-hidden" data-id="element-7">
        <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-8"></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#7B2CBF] rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/3" data-id="element-9"></div>

        <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-10">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-11">
            {/* Hero Text */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} className="space-y-6" data-id="element-12">
              <div className="inline-block bg-[#F4D35E] text-[#3C1361] font-bold px-3 py-1 rounded-full text-sm mb-2" data-id="element-13">
                ¡Éxito Viral!
              </div>
              <h1 className="font-heading text-5xl md:text-6xl font-black leading-tight text-white drop-shadow-md" data-id="element-14">
                El libro viral para resolver sudokus y crímenes
              </h1>
              <p className="text-xl text-[#F6E7A1] font-medium leading-relaxed" data-id="element-15">
                Un desafío de lógica distinto a todo: seguí las pistas, completá
                los tableros y descubrí al culpable en cada caso.
              </p>

              <ul className="space-y-3 text-lg" data-id="element-16">
                {['Libro digital completo', '80 páginas listas para descargar', 'Ideal para imprimir a color', 'Entrega inmediata', 'Entretenido, ingenioso y súper adictivo'].map((bullet, i) => <li key={i} className="flex items-center gap-3" data-id="element-17">
                    <CheckCircle2 className="text-[#F4D35E] shrink-0" size={24} data-id="element-18" />
                    <span data-id="element-19">{bullet}</span>
                  </li>)}
              </ul>

              <div className="pt-6" data-id="element-20">
                <div className="flex items-baseline gap-4 mb-4" data-id="element-21">
                  <span className="text-5xl font-black text-[#F4D35E]" data-id="element-22">
                    $19.990
                  </span>
                  <span className="text-2xl text-white/60 line-through decoration-[#C62828] decoration-2" data-id="element-23">
                    $29.990
                  </span>
                </div>

                <a href="#compra" onClick={e => {
                e.preventDefault();
                document.getElementById('compra')?.scrollIntoView({
                  behavior: 'smooth'
                });
              }} className="w-full md:w-auto bg-[#F4D35E] hover:bg-[#F6E7A1] text-[#3C1361] font-black text-xl py-4 px-8 rounded-xl shadow-[0_8px_0_#C62828] hover:shadow-[0_4px_0_#C62828] hover:translate-y-1 transition-all duration-200 flex items-center justify-center gap-3 uppercase" data-id="element-24">
                  Quiero descargarlo ahora
                  <Download size={24} data-id="element-25" />
                </a>

                <div className="flex items-center justify-center md:justify-start gap-2 mt-4 text-sm text-white/80 font-medium" data-id="element-26">
                  <ShieldCheck size={16} data-id="element-27" />
                  <span data-id="element-28">
                    Descarga inmediata · Acceso al instante · Formato digital
                  </span>
                </div>
              </div>
            </motion.div>

            {/* Hero Mockup */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative perspective-1000 flex justify-center" data-id="element-29">
              <div className="relative w-full max-w-md transform rotate-y-[-10deg] rotate-x-[5deg] hover:rotate-y-0 hover:rotate-x-0 transition-transform duration-500" data-id="element-30">
                <img src={COVER_URL} alt="Portada del libro" className="w-full h-auto rounded-r-lg book-shadow book-edge" data-id="element-31" />
                {/* Decorative elements */}
                <div className="absolute -bottom-6 -right-6 bg-white p-3 rounded-xl shadow-xl rotate-12" data-id="element-32">
                  <Printer className="text-[#5E1A8A]" size={32} data-id="element-33" />
                </div>
                <div className="absolute -top-6 -left-6 bg-[#F4D35E] p-3 rounded-full shadow-xl -rotate-12" data-id="element-34">
                  <Search className="text-[#3C1361]" size={32} data-id="element-35" />
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* 4. Cómo se juega */}
      <section className="py-20 bg-white relative" data-id="element-36">
        <div className="max-w-6xl mx-auto px-6" data-id="element-37">
          <div className="text-center mb-16" data-id="element-38">
            <h2 className="font-heading text-4xl md:text-5xl font-black text-[#3C1361] mb-4" data-id="element-39">
              ¿Cómo se juega?
            </h2>
            <p className="text-xl text-gray-600 font-medium" data-id="element-40">
              Una mezcla adictiva entre sudoku, lógica y misterio.
            </p>
          </div>

          <div className="grid md:grid-cols-5 gap-6 mb-12" data-id="element-41">
            {[{
            icon: FileText,
            title: 'Leé el caso',
            desc: 'Observá la escena, los personajes y las pistas disponibles.'
          }, {
            icon: Search,
            title: 'Analizá las pistas',
            desc: 'Cada dato te ayuda a ubicar correctamente a los sospechosos.'
          }, {
            icon: Brain,
            title: 'Completá el tablero',
            desc: 'Usá la lógica, como en un sudoku, sin repetir elementos.'
          }, {
            icon: Users,
            title: 'Descubrí quién fue',
            desc: 'Al resolver el tablero, encontrás al culpable.'
          }, {
            icon: CheckCircle2,
            title: 'Siguiente caso',
            desc: 'Cada página es un nuevo desafío, cada vez más entretenido.'
          }].map((step, i) => <motion.div key={i} whileHover={{
            y: -5
          }} className="bg-[#F7F1E3] p-6 rounded-2xl text-center border-2 border-transparent hover:border-[#F4D35E] transition-colors" data-id="element-42">
                <div className="w-16 h-16 mx-auto bg-[#5E1A8A] text-white rounded-full flex items-center justify-center mb-4 shadow-lg" data-id="element-43">
                  <step.icon size={32} data-id="element-44" />
                </div>
                <h3 className="font-heading font-bold text-lg mb-2 text-[#1E1E1E]" data-id="element-45">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-46">{step.desc}</p>
              </motion.div>)}
          </div>

          <div className="bg-[#F6E7A1] border-l-4 border-[#F4D35E] p-6 rounded-r-xl max-w-3xl mx-auto text-center shadow-sm" data-id="element-47">
            <p className="text-lg font-semibold text-[#3C1361]" data-id="element-48">
              💡 No necesitás experiencia previa. Solo ganas de pensar, resolver
              y divertirte.
            </p>
          </div>
        </div>
      </section>

      {/* 5. Qué incluye */}
      <section className="py-20 bg-[#5E1A8A] text-white relative overflow-hidden" data-id="element-49">
        <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-50"></div>
        <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-51">
          <h2 className="font-heading text-4xl md:text-5xl font-black text-center mb-16 text-[#F4D35E]" data-id="element-52">
            ¿Qué vas a recibir?
          </h2>

          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-53">
            {[{
            title: 'Libro digital completo',
            icon: FileText
          }, {
            title: '80 páginas de acertijos',
            icon: Brain
          }, {
            title: 'Archivo listo para descargar',
            icon: Download
          }, {
            title: 'Formato ideal para imprimir',
            icon: Printer
          }, {
            title: 'Diseño visual atractivo',
            icon: Search
          }, {
            title: 'Para hacer solo o compartir',
            icon: Users
          }].map((item, i) => <div key={i} className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl flex items-center gap-4 border border-white/20" data-id="element-54">
                <div className="bg-[#F4D35E] p-3 rounded-lg text-[#3C1361]" data-id="element-55">
                  <item.icon size={28} data-id="element-56" />
                </div>
                <span className="font-semibold text-lg" data-id="element-57">{item.title}</span>
              </div>)}
          </div>

          <div className="bg-white text-[#3C1361] p-8 rounded-2xl max-w-4xl mx-auto text-center shadow-2xl transform -rotate-1" data-id="element-58">
            <p className="text-2xl font-black font-heading" data-id="element-59">
              Lo comprás una vez, lo descargás al instante y lo podés imprimir
              cuando quieras.
            </p>
          </div>
        </div>
      </section>

      {/* 6. Video Section */}
      <section className="py-20 bg-[#F7F1E3]" data-id="element-60">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-61">
          <h2 className="font-heading text-4xl md:text-5xl font-black text-[#3C1361] mb-4" data-id="element-62">
            Mirá el libro por dentro
          </h2>
          <p className="text-xl text-gray-600 font-medium mb-12" data-id="element-63">
            Cómo son las páginas y cómo se resuelve.
          </p>

          <div className="bg-white p-4 rounded-3xl shadow-2xl mb-8 transform rotate-1" data-id="element-64">
            <div className="aspect-[9/16] md:aspect-video bg-black rounded-2xl overflow-hidden relative" data-id="element-65">
              <video src={VIDEO_URL} controls className="w-full h-full object-contain" poster={COVER_URL} data-id="element-66">
                Tu navegador no soporta el elemento de video.
              </video>
            </div>
          </div>

          <a href="#compra" onClick={e => {
          e.preventDefault();
          document.getElementById('compra')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="inline-block bg-[#C62828] hover:bg-red-800 text-white font-black text-xl py-4 px-10 rounded-xl shadow-[0_6px_0_#7f1d1d] hover:shadow-[0_3px_0_#7f1d1d] hover:translate-y-1 transition-all duration-200 uppercase tracking-wide" data-id="element-67">
            Quiero tenerlo hoy
          </a>
        </div>
      </section>

      {/* 7. Beneficios */}
      <section className="py-20 bg-white" data-id="element-68">
        <div className="max-w-6xl mx-auto px-6" data-id="element-69">
          <h2 className="font-heading text-4xl md:text-5xl font-black text-center text-[#3C1361] mb-16" data-id="element-70">
            ¿Por qué está gustando tanto?
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-71">
            {[{
            title: 'Es distinto a un sudoku común',
            desc: 'Olvidate de los números aburridos. Acá hay historia.'
          }, {
            title: 'Combina lógica + misterio',
            desc: 'Te sentís un detective resolviendo cada página.'
          }, {
            title: 'Perfecto para desconectarte',
            desc: 'Chau pantallas. Ideal para relajar la mente.'
          }, {
            title: 'Lo recibís al instante',
            desc: 'Cero esperas. Comprás y ya lo tenés en tu mail.'
          }, {
            title: 'Lo podés imprimir y compartir',
            desc: 'Armate unas copias y competí con tu familia.'
          }, {
            title: 'Para amantes de los desafíos',
            desc: 'Si te gusta pensar, te vas a volver fanático.'
          }].map((benefit, i) => <div key={i} className="flex gap-4 p-6 bg-[#F7F1E3] rounded-2xl" data-id="element-72">
                <div className="text-[#C62828] mt-1 shrink-0" data-id="element-73">
                  <CheckCircle2 size={28} data-id="element-74" />
                </div>
                <div data-id="element-75">
                  <h3 className="font-heading font-bold text-xl text-[#1E1E1E] mb-2" data-id="element-76">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-77">{benefit.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 8. Testimonios */}
      <section className="py-20 bg-[#F6E7A1] overflow-hidden" data-id="element-78">
        <div className="max-w-6xl mx-auto px-6 text-center mb-12" data-id="element-79">
          <h2 className="font-heading text-4xl md:text-5xl font-black text-[#3C1361] mb-4" data-id="element-80">
            Lo que dicen quienes ya lo compraron
          </h2>
        </div>

        <TestimonialCarousel data-id="element-81" />
      </section>

      {/* 9. CTA Final */}
      <section id="compra" className="py-24 bg-gradient-to-b from-[#3C1361] to-[#1E1E1E] text-white relative overflow-hidden" data-id="element-82">
        <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-83"></div>

        <div className="max-w-5xl mx-auto px-6 relative z-10 text-center" data-id="element-84">
          <div className="flex justify-center mb-10" data-id="element-85">
            <img src={COVER_URL} alt="Portada" className="w-48 rounded-lg book-shadow transform -rotate-6" data-id="element-86" />
          </div>

          <h2 className="font-heading text-4xl md:text-6xl font-black mb-6 text-[#F4D35E] leading-tight" data-id="element-87">
            Descargalo hoy y empezá a resolver tu primer caso
          </h2>

          <p className="text-xl text-gray-300 mb-10 max-w-3xl mx-auto" data-id="element-88">
            Si te gustan los desafíos mentales, los misterios y los juegos que
            te hacen pensar, este libro es para vos. Lo comprás, lo descargás y
            lo podés imprimir al instante.
          </p>

          <div className="bg-white/10 backdrop-blur-md border border-white/20 p-8 rounded-3xl max-w-md mx-auto mb-10" data-id="element-89">
            <div className="text-center mb-4" data-id="element-90">
              <span className="text-sm font-bold text-[#F4D35E] uppercase tracking-wider" data-id="element-91">
                Oferta promocional por tiempo limitado
              </span>
              <div className="mt-2 flex justify-center" data-id="element-92">
                <Countdown data-id="element-93" />
              </div>
            </div>

            <div className="text-6xl font-black text-white mb-6 font-heading" data-id="element-94">
              $19.990
            </div>

            <a href={CHECKOUT_URL} className="block w-full bg-[#F4D35E] hover:bg-[#F6E7A1] text-[#3C1361] font-black text-2xl py-5 px-8 rounded-xl shadow-[0_8px_0_#C62828] hover:shadow-[0_4px_0_#C62828] hover:translate-y-1 transition-all duration-200 uppercase" data-id="element-95">
              Comprar Ahora
            </a>

            <div className="flex flex-col items-center gap-2 mt-6 text-sm text-white/80" data-id="element-96">
              <div className="flex items-center gap-2" data-id="element-97">
                <ShieldCheck size={18} className="text-[#F4D35E]" data-id="element-98" />
                <span data-id="element-99">Acceso inmediato · Archivo digital</span>
              </div>
              <span className="opacity-75" data-id="element-100">Listo para descargar</span>
            </div>
          </div>
        </div>
      </section>

      {/* 10. FAQ */}
      <section className="py-20 bg-[#F7F1E3]" data-id="element-101">
        <div className="max-w-4xl mx-auto px-6" data-id="element-102">
          <h2 className="font-heading text-4xl font-black text-center text-[#3C1361] mb-12" data-id="element-103">
            Preguntas Frecuentes
          </h2>
          <FAQAccordion data-id="element-104" />
        </div>
      </section>

      {/* 11. Footer */}
      <footer className="bg-[#1E1E1E] text-white/70 py-16 border-t border-white/10" data-id="element-105">
        <div className="max-w-6xl mx-auto px-6" data-id="element-106">
          <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-10 mb-12" data-id="element-107">
            {/* Brand Section */}
            <div className="text-center md:text-left max-w-md" data-id="element-108">
              <div className="flex items-center justify-center md:justify-start gap-3 mb-4" data-id="element-109">
                <div className="bg-[#5E1A8A] p-2 rounded-lg" data-id="element-110">
                  <Brain className="text-[#F4D35E]" size={24} data-id="element-111" />
                </div>
                <h3 className="font-heading font-bold text-2xl text-white tracking-wide" data-id="element-112">
                  Atlas Digital Hub
                </h3>
              </div>
              <p className="text-lg text-white/90 font-medium mb-2" data-id="element-113">
                Productos digitales para aprender, crear y entretenerte
              </p>
              <p className="text-sm text-white/50 mb-4" data-id="element-114">
                Tienda digital de recursos, libros y productos descargables
              </p>
              <div className="inline-flex items-center gap-2 text-xs font-semibold bg-white/5 px-3 py-1.5 rounded-full text-[#F6E7A1]" data-id="element-115">
                <ShieldCheck size={14} data-id="element-116" />
                Producto 100% digital · Descarga inmediata · Uso personal
              </div>
            </div>

            {/* Links Section */}
            <div className="flex flex-col items-center md:items-end gap-4 text-sm" data-id="element-117">
              <h4 className="font-heading font-bold text-white tracking-widest mb-2" data-id="element-118">
                MURDOKU
              </h4>
              <a href="#" className="hover:text-white transition-colors" data-id="element-119">
                Términos y Condiciones
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-120">
                Políticas de Privacidad
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-121">
                Contacto
              </a>
            </div>
          </div>

          <div className="pt-8 border-t border-white/10 text-center text-xs text-white/40 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-122">
            <p data-id="element-123">
              © {new Date().getFullYear()} Atlas Digital Hub. Todos los
              derechos reservados.
            </p>
            <p data-id="element-124">Los resultados pueden variar según cada persona.</p>
          </div>
        </div>
      </footer>
    </div>;
}